<template>
  <TemplateContentSingle>
    <DisplaySection class="section">
      <ErrorLibraryBook
        v-if="type === ErrorTypes.LibraryBookMissing"
        :slug="params.slug"
      />
      <ErrorBase v-else :error="error" />
    </DisplaySection>
  </TemplateContentSingle>
</template>
<script setup lang="ts">
import { ErrorTypes, Eva2Error } from '~/lib/errors/Eva2Error';
type Props = {
  error: Eva2Error;
};
const props = defineProps({
  error: null
});

const { params, type } = props.error;
</script>
<style lang="scss" scoped>
.section {
  align-items: center;
  justify-content: center;
  height: 100%;
  height: calc(
    100dvh - var(--header_height) - var(--row_gap) - var(--row_gap) -
      var(--footer_height)
  );
}
.infos {
  max-width: 40rem;
  margin-bottom: 20vh;
  margin-bottom: 20dvh;
}
</style>
